// Shared canonical / anchor URL normalisation.
//
// Single source of truth so a plate page's self-referencing canonical and the
// crawlable anchor that links to it resolve to a byte-for-byte identical
// string. Used by route-data-service (canonical + og:url) and by
// search-result-row (the card's <a href>).
//
// Canonical plate destination is /plates/{REG} (SEO architecture spec). The
// older /plate/{REG} and /plate-detail/{REG} addresses 301 here at the CDN
// edge and redirect in-app.

// Production domain only — canonical/og:url never point at dev/dev2/localhost.
export const PRODUCTION_ORIGIN = 'https://www.platex.co.uk';

// Uppercase + remove all whitespace from a plate registration.
export function normaliseRegistration(reg: string): string {
  return (reg || '').toUpperCase().replace(/\s+/g, '');
}

// Site-relative path to a plate destination. This is exactly what the
// crawlable anchor uses for its href, and what every plate canonical collapses
// to (term segment + query intentionally dropped).
export function platePath(reg: string): string {
  return '/plates/' + normaliseRegistration(reg);
}

// Build an absolute canonical URL from a site-relative path:
//  - strip query string and fragment (removes session/tracking params)
//  - collapse duplicate slashes
//  - drop trailing slash (except root)
//  - prefix the production origin
export function toCanonicalUrl(path: string): string {
  let p = (path || '/').split('?')[0].split('#')[0];
  if (!p.startsWith('/')) {
    p = '/' + p;
  }
  p = p.replace(/\/{2,}/g, '/');
  if (p.length > 1 && p.endsWith('/')) {
    p = p.slice(0, -1);
  }
  return PRODUCTION_ORIGIN + p;
}
